<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content">
    <div class="modal-header">
      <aurora-icon-button class="close" type="button" (click)="close()" icon="times" size="large"></aurora-icon-button>
      <h4 class="modal-title">Cannot Complete Task</h4>
    </div>

    <div class="modal-body">
      <ep-panel panelType="transparent">
        <ep-row>
          <div class="col-12">
            <span style="font-size: 1.8em; font-weight: 500">
              According to the Workflow Plan, the following function(s) are required in order to complete this
              task:</span
            >
          </div>

          <div
            class="col-12"
            *ngFor="let event of missingEvents$ | async"
            style="display: inline-block; max-width: 100%"
          >
            <span style="font-size: 1.8em; color: blue; font-weight: 700">{{ event }}</span>
          </div>
        </ep-row>
      </ep-panel>
    </div>
    <div class="modal-footer">
      <aurora-button type="button" (click)="cancel()" variant="primary">Close</aurora-button>
    </div>
  </div>
</div>
